import { Routes, Route } from "react-router-dom";
import MainPage from "../pages/MainPage";
import PageNotFound from "../pages/PageNotFound";
import Report from "../pages/Report";
import CreateUser from "../components/userManagement/CreateUser";
import ComponentWrapper from "../components/ComponentWrapper";
import ReportLogs from "../components/report/ReportLogs";
import RateMaster from "../pages/RateMaster";
import SettingsWrapper from "../components/SettingsWrapper";
import GangMaster from "../pages/GangMaster";
import EmployeeMaster from "../pages/EmployeeMaster";
import EquipmentMaster from "../pages/EquipmentMaster";
import Notification from "../pages/Notification";
import Attendance from "../components/report/Attendance";
import WorkReport from "../components/workReport/WorkReport";
import Assignment from "../components/AssignEquipmentSupervisor/Assignment";
import AssignEquipmentToSupervisor from "../components/AssignEquipmentSupervisor/AssignEquipmentToSupervisor";
import ListContractorUsers from "../components/ContractorUsers/ListContractorUsers";
import AddContractorUsers from "../components/ContractorUsers/AddContractorUsers";
import ShiftManagement from "../pages/ShiftManagement";
import AddEditShift from "../components/ShiftManagement/AddEditShift";
import DailyActivity from "../pages/DailyActivity";
import Dashboard from "../pages/Dashboard";
import UserLog from "../components/ContractorUsers/UserLog";
import EquipmentReports from "../pages/EquipmentReports";
import SapExports from "../pages/SapExports";
import EquipmentReportDetails from "../pages/EquipmentReportDetails";

const AllRoutes = () => {
  return (
    <Routes>
      <Route path="*" element={<PageNotFound />} />
      <Route
        path="/dashboard"
        element={
          <ComponentWrapper navHeading={"Dashboard & Reports"} active={"dashboard"}>
            <Dashboard />
          </ComponentWrapper>
        }
      />
      <Route
        path="/logbook-reports"
        element={
          <ComponentWrapper navHeading={"Logbook Reports"} active={"logbookReports"}>
            <DailyActivity />
          </ComponentWrapper>
        }
      />
      <Route
        path="/equipment-reports"
        element={
          <ComponentWrapper navHeading={"Equipment Reports"} active={"equipmentReports"}>
            <EquipmentReports />
          </ComponentWrapper>
        }
      />
      <Route
        path="/sap-exports"
        element={
          <ComponentWrapper navHeading={"File Exported to SAP"} active={"sapExports"}>
            <SapExports />
          </ComponentWrapper>
        }
      />
      <Route
        path="/main-page"
        element={
          <ComponentWrapper navHeading={"Equipment QR Code"} active={"equipmentQrCode"}>
            <MainPage />
          </ComponentWrapper>
        }
      />
      <Route
        path="/report"
        element={
          <ComponentWrapper navHeading={"Logbook Report Details"} active={"logbookReports"}>
            <Report />
          </ComponentWrapper>
        }
      />
      <Route
        path="/equipment-report-details"
        element={
          <ComponentWrapper navHeading={"Equipment Report Details"} active={"equipmentReports"}>
            <EquipmentReportDetails />
          </ComponentWrapper>
        }
      />
      <Route
        path="/report/logs"
        element={
          <ComponentWrapper navHeading={"Report Logs"} active={"logbookReports"}>
            <ReportLogs />
          </ComponentWrapper>
        }
      />
      <Route
        path="/report/attendance"
        element={
          <ComponentWrapper navHeading={"Attendance"} active={"logbookReports"}>
            <Attendance />
          </ComponentWrapper>
        }
      />
      <Route
        path="/assign-equipment"
        element={
          <ComponentWrapper navHeading={"Assign Equipment to Supervisor"} active={"assignEquipment"}>
            <Assignment />
          </ComponentWrapper>
        }
      />
      <Route
        path="/contractor-users"
        element={
          <ComponentWrapper navHeading={"Contractor users"} active={"contractorUsers"}>
            <ListContractorUsers />
          </ComponentWrapper>
        }
      />
      <Route
        path="/add-contractor-users"
        element={
          <ComponentWrapper navHeading={"Contractor users"} active={"contractorUsers"}>
            <AddContractorUsers />
          </ComponentWrapper>
        }
      />
      <Route
        path="/user-logs"
        element={
          <ComponentWrapper navHeading={"User Logs"} active={"contractorUsers"}>
            <UserLog />
          </ComponentWrapper>
        }
      />
      <Route
        path="/work-report"
        element={
          <ComponentWrapper navHeading={"Work Report"} active={"workReport"}>
            <WorkReport />
          </ComponentWrapper>
        }
      />
      <Route path="/create-user" element={<CreateUser />} />
      <Route
        path="/assign-equipment-to-supervisor"
        element={
          <ComponentWrapper navHeading={"Assign Equipment to Supervisor"} active={"assignEquipment"}>
            <AssignEquipmentToSupervisor />
          </ComponentWrapper>
        }
      />
      <Route
        path="/shift-management"
        element={
          <ComponentWrapper navHeading={"Shift Management"} active={"shiftManagement"}>
            <ShiftManagement />
          </ComponentWrapper>
        }
      />
      <Route
        path="/add-shift"
        element={
          <ComponentWrapper navHeading={"Shift Management"} active={"shiftManagement"}>
            <AddEditShift />
          </ComponentWrapper>
        }
      />
      <Route
        path="/notification"
        element={
          <ComponentWrapper navHeading={"Notifications"} active={"notifications"}>
            <Notification />
          </ComponentWrapper>
        }
      />
      <Route
        path="/settings/rate-master"
        element={
          <SettingsWrapper navHeading={"Rate Master"} active={"rateMaster"}>
            <RateMaster />
          </SettingsWrapper>
        }
      />
      <Route
        path="/settings/gang-master"
        element={
          <SettingsWrapper navHeading={"Gang Master"} active={"gangMaster"}>
            <GangMaster />
          </SettingsWrapper>
        }
      />
      <Route
        path="/settings/employee-master"
        element={
          <SettingsWrapper navHeading={"Employee Master"} active={"employeeMaster"}>
            <EmployeeMaster />
          </SettingsWrapper>
        }
      />
      <Route
        path="/settings/equipment-master"
        element={
          <SettingsWrapper navHeading={"Equipment Master"} active={"equipmentMaster"}>
            <EquipmentMaster />
          </SettingsWrapper>
        }
      />
    </Routes>
  );
};

export default AllRoutes;
